import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { GlobalVariable, getBaseUrlForRequest } from '../global';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router); // Correct way
  const token = authService.getToken();

  let modifiedReq = req;
  let headers = req.headers;

  // API Gateway使用時のURL切り替えロジック
  if (environment.useApiGateway) {
    // GlobalVariable.BASE_URL（apiUrl）から始まるリクエストの場合のみ処理
    if (req.url.startsWith(GlobalVariable.BASE_URL)) {
      // リクエストパスを取得（BASE_URL以降の部分）
      const path = req.url.replace(GlobalVariable.BASE_URL, '');
      
      // 未登録のadminパスかチェック
      const isUnregisteredPath = environment.unregisteredAdminPaths?.some(
        adminPath => path.toLowerCase().includes(adminPath.toLowerCase())
      );
      
      if (isUnregisteredPath) {
        // 未登録パスは直接接続
        // /admin プレフィックスを削除してdirectApiUrlに接続
        const backendPath = path.replace(/^\/admin/i, '');
        const newUrl = (environment.directApiUrl || environment.apiUrl) + backendPath;
        modifiedReq = req.clone({ url: newUrl });
      }
      // 登録済みパスの場合はURL変更不要（すでにGlobalVariable.BASE_URLがAPI Gateway URL）
    }
  }

  // API Gatewayリクエストの判定とSubscription Key追加
  const isApiGatewayRequest = environment.useApiGateway && 
    (modifiedReq.url.includes('apigw-eu-prd.manpowergroup.com') ||
     modifiedReq.url.includes('apigw-EU-PRD.manpowergroup.com'));

  // API Gateway使用時は常にSubscription Keyを追加
  // if (isApiGatewayRequest && environment.apiGatewaySubscriptionKey) {
  //   headers = headers.set('Ocp-Apim-Subscription-Key', environment.apiGatewaySubscriptionKey);
  // }
  headers = headers.set('Ocp-Apim-Subscription-Key', environment.apiGatewaySubscriptionKey);
  // 後方互換性のため、GlobalVariableのSUBKEYもチェック
  // if (environment.useApiGateway && GlobalVariable.SUBKEY && GlobalVariable.SUBKEY_VALUE) {
  //   headers = headers.set(GlobalVariable.SUBKEY, GlobalVariable.SUBKEY_VALUE);
  // }
headers = headers.set(GlobalVariable.SUBKEY, GlobalVariable.SUBKEY_VALUE);
  // トークンが存在する場合、Authorizationヘッダーに追加
  const currentUrl = router.url;
  if (currentUrl !== '/login-sso') {
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }    
  }

  const requestWithHeaders = modifiedReq.clone({ headers });
  return next(requestWithHeaders);
};
